import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
const { RangePicker } = DatePicker;
const StyledRangePicker = styled(RangePicker)`
  background: #ffffff;
  border: 1px solid #d4d4d4;
  box-shadow: 0px 7px 64px rgba(0, 0, 0, 0.07);
  border-radius: 6px;
  &&:hover,
  :focus {
    border-right-width: 1px;
  }
  &&input,
  input::placeholder,
  .ant-picker-range-separator {
    font-size: 15px;
    line-height: 20px;
    color: #979ba4;
  }
  /* .anticon {
    display: none;
  } */
  .ant-picker-input > input {
    text-align: center;
  }
`;
const RangePickerCompo = ({ className, ...props }) => {
  return (
    <StyledRangePicker
      {...props}
      format="DD-MM-YYYY"
      className={className}
      allowClear={true}
      separator="to"
      showTime={false}
      // format={props.format}
    />
  );
};
RangePickerCompo.propTypes = {
  format: PropTypes.string,
};
RangePickerCompo.defaultProps = {
  // format: "YYYY/MM/DD",
  format: "DD-MM-YYYY",
};
export default RangePickerCompo;
